
export default {
  name: 'IndexPage',
  auth: false,
  data() {
    return {
      activeFinder: false,
      toggleList: 'total-rankings',
      guideText: '',
      container: {},
      form: {
        district_id: '',
        district: '',
        rankingUrl: 'total-rankings',
      },
      registerRates: {
        population: 0,
        count: 0,
        rate: 0,
      },

      districtRegisterCounts: [],
      rankingList: [],
      selected: '', // 지역 선택
      options: [
        // 지역 리스트
        '강원',
        '경기',
        '경남',
        '경북',
        '대구',
        '광주',
        '대전',
        '부산',
        '서울',
        '세종',
        '울산',
        '인천',
        '전남',
        '전북',
        '제주',
        '충남',
        '충북',
      ],
    };
  },
  computed: {
    district() {
      return this.$store.state.district;
    },
    uptoThreeDistrictRegisterCounts() {
      return this.districtRegisterCounts.slice(0, 3);
    },
  },
  methods: {
    getBadgeSrc(rankingCount) {
      if (rankingCount >= 1000 && rankingCount < 2000)
        return 'main_icon_badge_1k.png';
      if (rankingCount >= 2000 && rankingCount < 3000)
        return 'main_icon_badge_2k.png';
      if (rankingCount >= 3000) return 'main_icon_badge_3k.png';
      if (rankingCount < 1000) return false;
    },
    getScaleClass(rankingCount, rankingType = 'unranked') {
      if (rankingType === 'ranked') {
        if (rankingCount == 0) return 'bg-grey-30 ';
        if (rankingCount < 100) return 'bg-red-30 ';
        if (rankingCount >= 100) return 'bg-orange ';
      }
      if (rankingCount == 0) return 'bg-grey-30 more';
      if (rankingCount < 100) return 'bg-red-30 more up';
      if (rankingCount >= 100) return 'bg-orange more';
    },

    search() {
      if (this.form.district == '' || this.form.district == undefined) {
        return;
      }
      this.$store.commit('changeDistrict', this.form.district);
      // this.updatePosts(this.district.id);
      window.scrollTo(0, 0);
      this.container = {};
    },
    changeDistrict(data) {
      this.form.district = data.district;
    },

    async getRankings(state = '') {
      const response = await this.$axios.get(`/api/all-rankings`, {
        params: {
          state: state,
        },
      });
      if (response.data.result === true) {
        // 데이터 변환
        this.rankingList = response.data.districts
          .map((district) => {
            const districtDrafts = response.data.drafts
              .filter((draft) => draft.district_id === district.id)
              .map((draft) => ({
                group_at: draft.group_at,
                name: draft.name,
              }));

            return {
              id: district.id,
              state: district.state,
              city: district.city,
              district: district.district,
              count: district.count,
              population: district.population,
              drafts: districtDrafts,
            };
          })
          .filter((rank) => rank.population > 0 && rank.count > 0);
      }
      this.rankingList.sort((a, b) => b.count - a.count);
    },

    getGroupLetter(number) {
      // group_at을 a b c로 변경하기
      return String.fromCharCode(64 + Number(number)); // A는 65, B는 66, ...
    },
    async onSelectChange() {
      await this.getRankings(this.selected);
    },
  },

  watch: {},

  async mounted() {
    this.getRankings();
  },
};
